import { Typography } from '@mui/material';
import React from 'react'

const style = {
  title: {
    fontFamily: "ZapfHumnst BT",
    fontWeight: "400",
    fontSize: {
      xs: "11px",
      sm: "16px",
    },
    lineHeight: {
      xs: "13.62px",
      sm: "19.8px",
    },
    letterSpacing: "5%",
    color: "#181818",
    textAlign: "center",
  },
  welcome: {
    fontFamily: "ZapfHumnst BT",
    fontWeight: "400",
    fontSize: {
      xs: "20px",
      sm: "40px",
    },
    lineHeight: {
      xs: "24.76px",
      sm: "49.51px",
    },
    letterSpacing: {
      xs: "2%",
      sm: "5%",
    },
    color: "#181818",
    textAlign: "center",
  },
};

const SectionHeader = ({ title, description }) => {
  return (
    <>
      <Typography sx={style.title}>{title}</Typography>
      <Typography sx={style.welcome}>{description}</Typography>
    </>
  );
};

export default SectionHeader
